import React from "react";
import ComponentToPrint from "./InvoiceAndContractPrint";

function InVoicePreview() {
  return <ComponentToPrint />;
}

export default InVoicePreview;
